import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnDestroy, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, map, shareReplay, takeUntil } from 'rxjs/operators';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-shell',
  imports: [
    CommonModule,
    LanguageSelectorComponent,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MenuComponent,
    RouterModule
  ],
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements AfterViewInit, OnDestroy {
  //#region @viewchild --------------------------------------------------------
  @ViewChild('drawer', { static: false }) sidenav!: MatSidenav;
  //#endregion

  //#region private properties ------------------------------------------------
  private breakpointObserver: BreakpointObserver;
  private destroyed: Subject<void>;
  private disableClose = true;
  private overlayContainer: OverlayContainer;
  private router: Router = inject(Router);
  //#endregion

  //#region public properties -------------------------------------------------
  public themeColor: 'primary' | 'accent' | 'warn' = 'primary'; // ? notice this
  public isDark = false; // ? notice this
  public isHandset$: Observable<boolean>;
  public menuDivClass: string;
  public buttonDivClass: string;
  public sitenavContentClass: string;
  //#endregion

  //#region Constructor & C° ---------------------------------------------------
  public constructor(breakpointObserver: BreakpointObserver, overlayContainer: OverlayContainer) {
    this.breakpointObserver = breakpointObserver;
    this.overlayContainer = overlayContainer;
    this.destroyed = new Subject<void>();
    this.disableClose = true;
    this.menuDivClass = 'menu-div-70';
    this.buttonDivClass = 'button-div-70';
    this.sitenavContentClass = 'shell-sitenav-content';
  }

  ngOnInit(): void {
    this.isHandset$ = this.breakpointObserver.observe([Breakpoints.HandsetPortrait, Breakpoints.XSmall]).pipe(
      takeUntil(this.destroyed),
      map((result) => {
        this.menuDivClass = result.matches ? 'menu-div-62' : 'menu-div-70';
        this.sitenavContentClass = result.matches ? '' : 'shell-sitenav-content';
        if (this.sidenav) {
          this.sidenav.disableClose = !result.matches;
        }
        this.disableClose = !result.matches;

        return result.matches;
      }),
      shareReplay()
    );
  }

  ngAfterViewInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.sidenav && !this.sidenav.disableClose && !this.disableClose) {
        void this.sidenav.close();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
  //#endregion

  //#region UI triggered methods ----------------------------------------------
  public toggleTheme(): void {
    this.isDark = !this.isDark;
    if (this.isDark) {
      this.overlayContainer.getContainerElement().classList.add('dark-theme');
    } else {
      this.overlayContainer.getContainerElement().classList.remove('dark-theme');
    }
  }
  //#endregion
}
